import React, { useEffect } from "react";
import { config } from "@triare/auth-redux";
import Layout from "../../components/Layout";
import CreateTopDonorContent from "../../components/Pages/Donations";

const { displayName } = config;

export default function Donations() {
  useEffect(() => {
    document.title = `${displayName}: Donations`;
  }, []);

  return (
    <Layout>
      <CreateTopDonorContent />
    </Layout>
  );
}
